var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chrome-svgrepo-com",
    transform: "translate(-2.036 -2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34569",
    "data-name": "Path 34569",
    d: "M12.717,2A10.365,10.365,0,0,1,21.77,7.511H12.214A4.347,4.347,0,0,0,8.87,9.576a4.221,4.221,0,0,0-.384,3.615C7.717,11.927,4.4,6.334,4.4,6.334A9.993,9.993,0,0,1,12.717,2Z",
    transform: "translate(-0.716 0)",
    fill: "#ef3f36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34570",
    "data-name": "Path 34570",
    d: "M24.214,19.017a10,10,0,0,1-9.19,4.845c.807-1.392,4.65-8.023,4.65-8.023A4.16,4.16,0,0,0,19.508,12a4.344,4.344,0,0,0-2.955-2.129c1.472-.013,7.944,0,7.944,0A9.635,9.635,0,0,1,24.214,19.017Z",
    transform: "translate(-3.459 -1.909)",
    fill: "#fcd900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34571",
    "data-name": "Path 34571",
    d: "M3.308,18.554A9.932,9.932,0,0,1,3.693,8.2c.8,1.392,4.648,8.023,4.648,8.023A4.191,4.191,0,0,0,11.761,18a4.367,4.367,0,0,0,3.329-1.483c-.724,1.276-3.972,6.854-3.972,6.854a9.707,9.707,0,0,1-7.81-4.816Z",
    transform: "translate(0 -1.406)",
    fill: "#61bc5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34572",
    "data-name": "Path 34572",
    d: "M15.02,27.024l1.308-5.438a4.391,4.391,0,0,0,2.643-1.429C18.223,21.468,15.02,27.024,15.02,27.024Z",
    transform: "translate(-3.655 -5.022)",
    fill: "#5ab055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34573",
    "data-name": "Path 34573",
    d: "M9.72,14.207a4.357,4.357,0,1,1,4.357,4.341A4.35,4.35,0,0,1,9.72,14.207Z",
    transform: "translate(-2.092 -2.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34574",
    "data-name": "Path 34574",
    d: "M10.766,14.522a3.628,3.628,0,1,1,3.628,3.615A3.621,3.621,0,0,1,10.766,14.522Z",
    transform: "translate(-2.408 -2.457)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34575",
    "data-name": "Path 34575",
    d: "M25.156,9.875l-5.385,1.574a4.376,4.376,0,0,0-2.559-1.574C18.727,9.867,25.156,9.875,25.156,9.875Z",
    transform: "translate(-4.121 -2.237)",
    fill: "#eaca05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34576",
    "data-name": "Path 34576",
    d: "M8.27,14.871C7.514,13.565,4.4,8.212,4.4,8.212l3.988,3.931a3.9,3.9,0,0,0-.256,2.041l.135.687Z",
    transform: "translate(-0.716 -1.721)",
    fill: "#df3a32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeSvgrepoCom);
export default __webpack_public_path__ + "static/media/chrome-svgrepo-com.ee603f9ebdb93b0fd8e32d439878bd2e.svg";
export { ForwardRef as ReactComponent };